import { useEffect } from 'react';

const useOnScrollEvent = (condition = true, callback) => {
  useEffect(() => {
    function watchScroll() {
      window.addEventListener('scroll', callback);
    }
    if (condition) {
      watchScroll();
    }
    return () => {
      window.removeEventListener('scroll', callback);
    };
  });
};
export { useOnScrollEvent };
